import React, {useEffect, useState, Fragment} from 'react';
import {Section, Popup, List} from '../../../components';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import GroupIcon from '@material-ui/icons/Group';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import CardMembershipIcon from '@material-ui/icons/CardMembership';
import EmailIcon from '@material-ui/icons/Email';
import ScheduleIcon from '@material-ui/icons/Schedule';
import PersonIcon from '@material-ui/icons/Person';
import Switch from '@material-ui/core/Switch';
import {loadStripe} from '@stripe/stripe-js';
import {connect} from 'react-redux';
import axios from 'axios';

export default function EnterpriseSubscription(props){
  let stripe_key="pk_test_51IxBXwICUHW9YTF61u7Yd5bEexcExlxvniyeDVfsLzXhNLGTRssWNYCfejyivigksfIW0P3Fo5Jnz4hkmqLYOZC6000i5E87EX";
  let stripePromise;
  if(props.workspace!=undefined){
    if(props.workspace.test==false){ stripe_key='pk_live_51IxBXwICUHW9YTF6DSIomoISs3Njej53kWb1AOzjqkbzsOgv058hvtxaP81nge7eRyy74KsnVNg0sSxPKQmKzXvc00LnBQ8nni' }
    stripePromise = loadStripe(stripe_key);
  }
  const [upgrade_downgrade_confirmation, setUpgradeDowngradeConfirmation]=useState(undefined);

  async function checkout(session_id){const stripe = await stripePromise; const { error } = await stripe.redirectToCheckout({sessionId:session_id});}
  const [s, setS]=useState(undefined);

  useEffect(()=>{
    axios.get('/api/enterpriseSubscription/'+props.match.params.id).then((res)=>{
      setS(res.data);
    })
  },[]);

  if(props.workspace_data==undefined || s==undefined || s==null){return(null);}else{
    s.add_ons=[
      {id:1, name:<div style={{position:'relative'}}><img style={{height:'27px', marginTop:'0px', marginLeft:'5px', position:'absolute', top:'-10px'}} src='/images/gmail.png'/></div>, descripion:'asdfas', includes:'asdfa', included:true, text:'Included'},
      {id:1, name:<img style={{height:'15px', marginLeft:'5px'}} src='/images/hubspot.png'/>, descripion:'asdfas', includes:'asdfa', included:true, text:'Included'},
      {id:1, name:<Grid container><Grid item xs={2}><EmailIcon style={{height:'15px', marginRight:'5px'}} variant='primary'/></Grid><Grid item xs={6}>Templates</Grid></Grid>, descripion:'asdfas', includes:'asdfa', included:true, text:(s.max_templates==null)?'Unlimited':('Max. '+s.max_templates)},
      {id:1, name:<Grid container><Grid item xs={2}><ScheduleIcon style={{height:'15px', marginRight:'5px'}} variant='primary'/></Grid><Grid item xs={6}>Sequences</Grid></Grid>, descripion:'asdfas', includes:'asdfa', included:true, text:(s.max_sequences==null)?'Unlimited':('Max. '+s.max_sequences)},
    ];
    s.price_per_year=s.currency+((s.subscription_interval=='YEAR')?s.amount:s.amount*12); s.price_per_year='Billed annually'
    s.price_per_month=s.currency+((s.subscription_interval=='MONTH')?s.amount:s.amount/12);
    let max_u='Max users: '; if(s.max_users==null){max_u=max_u+'unlimited';}else{max_u=max_u+s.max_users;}
    let monthly_credits='unlimited'; if(s.credits!=undefined){monthly_credits=s.credits;} monthly_credits=monthly_credits+' monthly credits per person';
    return(
      <Fragment>
      <Section icon={<BusinessCenterIcon color='primary'/>} title={s.name} maxWidth='400px'>
        <div style={{width:'100%', display:'flex', alignItems:'center', justifyContent:'center', marginTop:'10px', marginBottom:'10px', marginTop:'-10px'}}>
          <span><Typography style={{fontSize:'60px'}}>{s.price_per_month+' '}</Typography></span>
          <span style={{marginRight:'-50px'}}><Typography >{(s.per_person==true)?'/per month per person':'/per month'}</Typography></span>
        </div>
        <Typography style={{width:'100%', textAlign:'center', marginTop:'10px', marginBottom:'10px', fontSize:'20px'}}>{s.price_per_year}</Typography>
        <Typography variant='caption' style={{textAlign:'center', marginBottom:'30px'}}>{s.description}</Typography>
        <Grid container><Grid item xs={2}>{<PersonIcon variant='outlined' color='primary' size='small'/>}</Grid><Grid xs={10}><Typography>{max_u}</Typography></Grid></Grid>
        <hr style={{width:'100%', marginTop:'10px', marginBottom:'10px'}}/>
        <Grid container><Grid item xs={2}>{<MonetizationOnIcon variant='outlined' color='primary' size='small'/>}</Grid><Grid xs={10}><Typography>{monthly_credits}</Typography></Grid></Grid>
        {(1==1)?null:<Grid container><Grid item xs={2}>{<MonetizationOnIcon variant='outlined' color='secondary' size='small'/>}</Grid><Grid xs={10}><Typography>60 credits topup</Typography></Grid></Grid>}
        <hr style={{width:'100%', marginTop:'10px', marginBottom:'10px'}}/>
        <div>{s.add_ons.map(function(tp){return(<div>
          <Tooltip title={tp.description}>
            <Grid container>
              <Grid item xs={1}>-</Grid>
              <Grid item xs={6}><Typography>{tp.name}</Typography></Grid>
              <Grid item xs={2}><Typography style={{color:(tp.included==true)?'green':undefined}}>{tp.text}</Typography></Grid>
            </Grid>
          </Tooltip>
          </div>)})}
        </div>
        <hr style={{width:'100%', marginTop:'10px', marginBottom:'10px'}}/>
        <div style={{position:'relative', display:'flex', justifyContent:'center', alignItems:'center', width:'100%'}}><Button color={'primary'} variant='contained' onClick={(e)=>{
          if(props.workspace.active_subscription.prospect_safari_service_id==null){axios.post('/api/payments/'+s.id).then(function(response){checkout(response.data.id)});
        }else{
            axios.get('/api/payments/'+s.id+'/preview').then(function(data){setUpgradeDowngradeConfirmation({...data.data, id:s.id});})}
        }}>{(props.workspace.active_subscription.prospect_safari_service_id!=null)?"Upgrade":"Subscribe"}</Button></div>
      </Section>
      {(upgrade_downgrade_confirmation==undefined)?null:<UpgradeDowngradeConfirmation {...props} data={upgrade_downgrade_confirmation} charge={(id)=>{axios.post('/api/payments/'+id).then(function(response){window.location.href='/payments/active';});}} handleClose={()=>{setUpgradeDowngradeConfirmation(undefined);}}/>}
      </Fragment>
    )
    }
}





function UpgradeDowngradeConfirmation(props){
  const[second_confirmation, setSecondConfirmation]=useState(false);

  return(<Popup accept_button={(second_confirmation==true)?"Pay":"Continue"} accept_button_click={()=>{if(second_confirmation==false){setSecondConfirmation(true);}else{props.charge(props.data.id); props.handleClose();}}} handleClose={props.handleClose} always_open title={'Invoice confirmation'} content={
            <Fragment>
              {(second_confirmation==false)?
              <div style={{width:'90%', maxWidth:'700px', padding:'20px', height:'200px'}}>
                {props.data.lines.data.map(function(d){
                  return(<Typography>{(d.amount/100)+" "+d.currency+": "+d.description}</Typography>)
                })}
                <hr style={{width:'100%', marginTop:'10px', marginBottom:'10px'}}/>
                <Typography>{"You will be charged a total of "+(props.data.amount_due/100)+" "+props.data.currency+" for the first period"}</Typography>
                {(props.data.ending_balance==0)?null:<Typography>{"You will also have a balance of "+(-props.data.ending_balance/100)+" "+props.data.currency+" which will be used in future transactions"}</Typography>}
              </div>
              :
              <div style={{width:'90%', maxWidth:'700px', padding:'20px', height:'200px', display:'flex', justifyContent:'center', alignItems:'center'}}>
                <Typography>{"Do you wish to proceed? You will be charged "+(props.data.amount_due/100)+" "+props.data.currency+" for the first period"}</Typography>
              </div>}
            </Fragment>
          }/>
        )
}
